import { LinkedRelationshipsForm_P_PL } from '../../../private/LinkedRelationships_P_PL';

/**
 * - OtherBusiness (LTD, PLC, Other, Unlimited, Partnership)
 * - FinancialProduct
 */
export const LinkedRelationshipsForm_OB_FP = LinkedRelationshipsForm_P_PL;
